import { moveToLink } from "@socar-inc/web-frontend-libraries";

export const moveToInternal = (url: string) => {
  moveToLink(`socar-v2://open-url/internal?url=${encodeURIComponent(url)}`);
};
